export default __webpack_public_path__ + "assets/images/vote-thumb-icon.b2fbc76ef3d3a590e30ba1b1993392c7.png";